// store.js
import { configureStore } from '@reduxjs/toolkit';
import { addBlogReducers, getBlogReducer } from './Reducers/BlogReducer';
import { addJobReducers,getJobReducer} from './Reducers/JobReducer';
import { adminUserReducers, getPermissionsReducer, getRoleReducer, newUserReducers, updatePasswordReducers, userReducers } from './Reducers/UserReducers';



const Store = configureStore({
    reducer: {
        blog: addBlogReducers,
        allBlogs: getBlogReducer,
        addJob : addJobReducers,
        getAllJobs : getJobReducer,    
        user: userReducers,
        newUser: newUserReducers,
        updatePassword: updatePasswordReducers,
        adminUsers: adminUserReducers,
        adminRoles : getRoleReducer,
        permissions: getPermissionsReducer

    },
});

export default Store;
